document.querySelectorAll("[data-rbf4-product]").forEach((root) => {
  const mainImage = root.querySelector("[data-rbf4-main-image]");
  const thumbnails = Array.from(root.querySelectorAll("[data-rbf4-thumbnail]"));
  const previousButton = root.querySelector("[data-rbf4-gallery-previous]");
  const nextButton = root.querySelector("[data-rbf4-gallery-next]");
  const galleryStatus = root.querySelector("[data-rbf4-gallery-status]");
  let currentImageIndex = Math.max(
    0,
    thumbnails.findIndex((thumbnail) => thumbnail.getAttribute("aria-current") === "true"),
  );

  const showImage = (requestedIndex) => {
    if (!mainImage || thumbnails.length === 0) return;

    const nextIndex = (requestedIndex + thumbnails.length) % thumbnails.length;
    const thumbnail = thumbnails[nextIndex];

    // Shopify's image_tag outputs a responsive srcset. Clear it before changing
    // src so the browser does not keep rendering the original responsive image.
    mainImage.removeAttribute("srcset");
    mainImage.removeAttribute("sizes");
    mainImage.src = thumbnail.dataset.image;
    mainImage.alt = thumbnail.dataset.alt || "";

    thumbnails.forEach((item, index) => {
      item.setAttribute("aria-current", String(index === nextIndex));
    });

    currentImageIndex = nextIndex;
    if (galleryStatus) {
      galleryStatus.textContent = `Product image ${nextIndex + 1} of ${thumbnails.length}`;
    }
  };

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", () => {
      showImage(index);
    });
  });

  previousButton?.addEventListener("click", () => showImage(currentImageIndex - 1));
  nextButton?.addEventListener("click", () => showImage(currentImageIndex + 1));

  root.querySelectorAll("[data-rbf4-form]").forEach((form) => {
    const variantSelect = form.querySelector("[data-rbf4-variant]");
    const price = root.querySelector("[data-rbf4-price]");
    const availability = root.querySelector("[data-rbf4-availability]");
    const submit = form.querySelector("[data-rbf4-submit]");
    const submitLabel = submit?.querySelector("[data-rbf4-submit-label]");

    variantSelect?.addEventListener("change", () => {
      const option = variantSelect.selectedOptions[0];
      const available = option?.dataset.available === "true";
      const priced = Number(option?.dataset.priceCents || 0) > 0;
      const ready = available && priced;

      if (price) {
        price.textContent = priced ? option?.dataset.price : price.dataset.pendingText;
      }
      if (availability) {
        availability.textContent = !priced
          ? availability.dataset.pendingText
          : available
            ? availability.dataset.availableText
            : availability.dataset.soldoutText;
        availability.classList.toggle("is-available", ready);
      }
      if (submit) submit.disabled = !ready;
      if (submitLabel) {
        submitLabel.textContent = !priced
          ? submitLabel.dataset.pendingText
          : available
            ? submitLabel.dataset.availableText
            : submitLabel.dataset.soldoutText;
      }
    });
  });
});
